import styled from 'styled-components';
import { CountLabel } from '../visuals/CountLabel';
import {
  NO_EXPORT_CLASS_NAME,
  REFERENCE_ID_ATTRIBUTE,
} from '@ardoq/global-consts';
import { HoverPath } from '../visuals/EdgePath';
import type { RelationshipsLink } from './types';
import { DiffType } from '@ardoq/data-model';
import { ArdoqId } from '@ardoq/api-types';
import { noop } from 'lodash';
import { isAggregatedGraphEdge } from '../graphItems/predicates';

const Link = styled.path`
  .parent-child-reference {
    color: black;
    stroke: black;
    stroke-dasharray: 2;
  }
`;
interface RelationshipsViewLinkProperties {
  link: RelationshipsLink;
  selectedReferenceId?: ArdoqId | null;
  onReferenceClick?: (referenceId: ArdoqId) => void;
}
const RelationshipsViewLink = ({
  link,
  selectedReferenceId,
  onReferenceClick = noop,
}: RelationshipsViewLinkProperties) => {
  const cssClassNames = link.edge.getCSS({
    useAsBackgroundStyle: false,
  });
  const contextMenuDataAttribute = {
    [REFERENCE_ID_ATTRIBUTE]: link.edge.modelId,
  };
  return (
    <g
      data-global-handler-id={link.edge.modelId}
      className="link"
      onClick={event => {
        if (!link.edge.isReference()) return;
        onReferenceClick(link.edge.modelId);
        event.stopPropagation();
      }}
    >
      <Link
        className={cssClassNames}
        markerStart={`url(#${link.edge.getLineBeginning()})`}
        markerEnd={`url(#${link.edge.getLineEnding()})`}
        {...contextMenuDataAttribute}
      />
      <HoverPath
        $isSelected={selectedReferenceId === link.edge.modelId}
        $diffType={DiffType.NONE}
        className={`integration hoverPath ${NO_EXPORT_CLASS_NAME} ${cssClassNames}`}
        {...contextMenuDataAttribute}
      />
      {isAggregatedGraphEdge(link.edge) && (
        <CountLabel count={link.edge.modelIds.length} />
      )}
    </g>
  );
};

export { RelationshipsViewLink };
